// @flow
import * as React from 'react';

import {
  ComposableTable,
  getButtonCellGenerator,
  getErrorCellGenerator,
  getTextCellGenerator,
  getTimestampCellGenerator,
  wrapInHoverCell,
} from 'components/ComposableTable';
import Row from 'components/Row.jsx';
import Text from 'components/Text.jsx';

type Props = {
  unsentFileUploads: $ReadOnlyArray<*>,
};

export default class AdminAutoMessageDetailUnsentFilesTable extends React.Component<Props, void> {
  formatDataToRow = (unsentFile: *) => {
    const { uploadedAt, studentIdList, uuid } = unsentFile;

    if (!studentIdList) {
      return {
        uuid,
        uploadedAt,
        recipientErrors: 'N/A',
        recipientCount: 'N/A',
      };
    }

    const {
      includeParents,
      includeStudents,
      unmatchedStudentsCount,
      studentsWithoutParentsCount,
      parentsCount,
      studentsCount,
    } = studentIdList;

    const recipientCounts = [];
    if (includeParents) {
      recipientCounts.push(parentsCount);
    }
    if (includeStudents) {
      recipientCounts.push(studentsCount);
    }
    const recipientCount =
      recipientCounts.length > 0 ? recipientCounts.reduce((acc, curr) => acc + curr) : 0;

    return {
      uuid,
      uploadedAt: new Date(uploadedAt),
      recipientErrors: studentsWithoutParentsCount + unmatchedStudentsCount,
      recipientCount,
    };
  };

  render() {
    const { unsentFileUploads } = this.props;
    const columnHeaders = [
      { name: 'CSV transfer time' },
      { name: 'Selected recipients' },
      { name: 'Recipient errors' },
      { name: '' },
    ];

    const columnGenerators = [
      getTimestampCellGenerator('uploadedAt'),
      getTextCellGenerator('recipientCount'),
      getErrorCellGenerator('recipientErrors'),
      wrapInHoverCell(
        getButtonCellGenerator({
          fieldForAction: 'uuid',
          // placeholder for real action
          onClickAction: () => undefined,
          buttonLabel: 'View details',
          buttonProps: { level: 'secondary', size: 'xsmall' },
        })
      ),
    ];
    const rows = unsentFileUploads.map(unsentFile => this.formatDataToRow(unsentFile));
    return (
      <React.Fragment>
        <Row size="small">
          <Text size="small" lineHeight="large">
            These messages were not sent. To see who they would have been sent to, click{' '}
            <Text weight="semibold">View details</Text> below.
          </Text>
        </Row>
        <ComposableTable
          data-test="unsent-uploads-table"
          columnHeaders={columnHeaders}
          columnGenerators={columnGenerators}
          rows={rows}
          keyField="uuid"
          rightAlignedLastColumn
        />
      </React.Fragment>
    );
  }
}
